import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import {useForm, useWatch} from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import {FormTextField} from "../../../../components/fields";
import {RentalType} from "../../../../types";
import {IFormValues, InsertBookingStep} from "../../types";
import {
    FormCarGroup,
    FormCig,
    FormCustomerCode,
    FormDropoffDate,
    FormDropoffLocation,
    FormLockGroup,
    FormPickupDate,
    FormPickupLocation,
    FormRentalType,
    FormVehicleCategory
} from "./fields";
import FormMileageIncluded from "./fields/FormMileageIncluded";
import {businessAgreementCig, isBusinessContinuityMode, stepState} from "../../recoil";
import FormBookingDateTime from "./fields/FormBookingDateTime";
import TenantForm from "../../../../components/multitenant/TenantForm";
import DealerForm from "../../../../components/multitenant/DealerForm";
import {useContext} from "react";
import {GlobalContext} from "../../../../../../util/state/GlobalContextProvider";

const BasicDetails = () => {

    const { t } = useTranslation('booking');
    const { globalData } = useContext(GlobalContext);
    const form = useForm<IFormValues>();
    const rentalType = useWatch<IFormValues, 'basicDetails.rentalType'>({
        name: 'basicDetails.rentalType'
    });

    const tenantsWatch = useWatch<IFormValues, 'basicDetails.tenants'>({
        name: 'basicDetails.tenants',
        control: form.control
    });

    // useEffect(() => {
    //     console.log({ tenantsWatch });
    // }, [tenantsWatch]);

    const step = useRecoilValue(stepState);
    const hasCig = useRecoilValue<boolean | undefined>(businessAgreementCig);

    const businessContinuityMode = useRecoilValue(isBusinessContinuityMode);

    const onChangeLegalEntityDealer = ( field: 'tenants' | 'dealers' , newValue: string) => {
        // if (field === 'tenants') {
        //     form.setValue("basicDetails.dealers", null);
        // }
        form.setValue(`basicDetails.${field}`, newValue);
    }

    return (
        <Card>
            <CardHeader title={t('label.mainDetails')} />
            <CardContent>
                <Grid container rowSpacing={1} columnSpacing={3}>
                    {
                        !(globalData?.user.legalEntities.length === 1 && globalData?.user.dealers.length === 1) &&
                        <Grid item xs={12} lg={6} sm={6}>

                            <TenantForm
                                name={"basicDetails.tenants"}
                                onChange={(e: any, newValue: any) => onChangeLegalEntityDealer('tenants', newValue)}
                                multiple={false}
                                disabled={step === InsertBookingStep.CUSTOMER_DETAILS}
                            />
                        </Grid>
                    }
                    {
                        !(globalData?.user.legalEntities.length === 1 && globalData?.user.dealers.length === 1) &&
                        <Grid item xs={12} lg={6} sm={6}>
                            <DealerForm
                                name={"basicDetails.dealers"}
                                tenants={tenantsWatch}
                                onChange={(e: any, newValue: any) => onChangeLegalEntityDealer('dealers', newValue)}
                                multiple={false}
                                disabled={step === InsertBookingStep.CUSTOMER_DETAILS}
                            />
                        </Grid>
                    }
                    <Grid container item columnSpacing={3} rowSpacing={2}>
                        <Grid container item xs={12} alignItems="center" columnGap={4}>
                            <FormRentalType />
                        </Grid>
                    </Grid>
                    {(rentalType === RentalType.CORPORATE) &&
                        <Grid container item columnSpacing={3} rowSpacing={2}>
                            <Grid item xs={12} sm={6}>
                                <FormCustomerCode />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="basicDetails.dossierNumber"
                                    label={t('label.dossierNumber')}
                                    disabled={step === InsertBookingStep.CUSTOMER_DETAILS}
                                />
                            </Grid>
                             { hasCig &&
                                <>
                                    <Grid item xs={12} sm={6}>
                                        <FormCig  />
                                    </Grid>
{/*                                    <Grid item xs={12} sm={6}>
                                        <FormCup  />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormOrderCode  />
                                    </Grid>*/}
                                </>
                            }
                        </Grid>
                    }
                    {businessContinuityMode && 
                        <>
                            <Grid item xs={12} sm={6}>
                                <FormBookingDateTime />
                            </Grid>
                            <Grid item xs={12} sm={6}/>
                        </>
                    }

                    <Grid item xs={12} sm={6}>
                        <FormPickupLocation />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormDropoffLocation />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormPickupDate />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormDropoffDate />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormVehicleCategory />
                    </Grid>
                    <Grid container item xs={12} sm={6} columnGap={2} alignItems="start" flexWrap="nowrap" mt={1}>
                        <Grid item xs>
                            <FormCarGroup />
                        </Grid>
                        <Grid container item xs="auto" mt={1}>
                            <FormLockGroup />
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <FormMileageIncluded />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default BasicDetails;
